'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = meTransform;

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _toLower = require('lodash/toLower');

var _toLower2 = _interopRequireDefault(_toLower);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function meTransform(data) {
  var _get = (0, _get3.default)(data, 'user', {}),
      bannerImageUrl = _get.bannerImageUrl,
      imageUrl = _get.imageUrl,
      userId = _get.userId,
      userName = _get.userName,
      firstName = _get.firstName,
      lastName = _get.lastName,
      followers = _get.followers,
      isFollowingListPublic = _get.isFollowingListPublic,
      isRegistered = _get.isRegistered,
      subscriptions = _get.subscriptions,
      email = _get.email;

  var currentSub = (0, _get3.default)(subscriptions, ['edges', '0', 'node'], {});

  return {
    content: {
      id: userName,
      accountId: userId,
      isFollowingListPublic: isFollowingListPublic,
      userName: userName,
      bannerImage: bannerImageUrl,
      image: imageUrl,
      subtitle: userName,
      title: firstName + ' ' + lastName,
      followerCount: (0, _get3.default)(followers, 'totalCount', 0),
      isRegisteredUser: isRegistered,
      subscriptionKey: currentSub.key,
      subscriptionProviderName: currentSub.providerName,
      subscriptionStatus: (0, _toLower2.default)(currentSub.status),
      email: email
    }
  };
}
//# sourceMappingURL=me.js.map